import { db } from "../../../mp-database"
import forOwn from "mout/object/forOwn"
import { fromPairs } from "lodash"

export default async function assignTeacherToStudents(record, students) {
  const studentRefs = students.map(student =>
    db.collection("students").doc(student.id)
  )
  const teacherKey = `teachers.${record.teacher}`
  let studentStatus = fromPairs(students.map(student => [student.id, false]))

  const querySnap = await db
    .collection("classes")
    .where("teacher", "==", record.teacher)
    .get()

  querySnap.docs.forEach(doc => {
    if (doc.id !== record.id) {
      forOwn(doc.get("students"), (stdData, stdKey) => {
        if (stdData) {
          studentStatus[stdKey] = true
        }
      })
    }
  })

  const batch = db.batch()
  studentRefs.forEach(ref => {
    batch.update(ref, { [teacherKey]: studentStatus[ref.id] })
  })

  await batch.commit()
  return studentStatus
}
